import _extends from "@babel/runtime/helpers/esm/extends";
import { useEffect } from 'react';
import Inputmask from 'inputmask';

var useInputMask = function useInputMask(ref, mask, options) {
  useEffect(function () {
    if (ref && ref.current && mask) {
      // We need the import to happen in the useEffect, and not at the top.
      // Hooks are not regarded in SSR environments, and Inputmask lib
      // uses window object directly. For this reason, the import is needed
      // in the hook, so it is excluded in SSR environments.
      // eslint-disable-next-line global-require
      var im = new Inputmask(mask, _extends({
        clearMaskOnLostFocus: false
      }, options));
      im.mask(ref.current);
    }
  }, [ref]);
};

export default useInputMask;